import React from "react"
import { ControlPanelButton } from "../control-panel-button";
import { ControlPanelStyle } from "./styled";

export const ControlPanel = () => {

    return (
        <ControlPanelStyle>
            <ControlPanelButton />
        </ControlPanelStyle>
    )
}